module.exports = __webpack_public_path__ + "static/media/stadeAthenes.7fa0fff2.jpg";